function LockedVector() {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="48"
			height="48"
			fill="none"
			viewBox="0 0 48 48"
		>
			<g clipPath="url(#clip0_0:2325)">
				<path
					fill="url(#paint0_linear_0:2325)"
					d="M23.67 43.696c10.697 0 19.367-8.671 19.367-19.367 0-10.695-8.67-19.366-19.366-19.366S4.305 13.633 4.305 24.33s8.67 19.367 19.366 19.367z"
				></path>
				<path
					fill="url(#paint1_linear_0:2325)"
					d="M36.962 5.208L26.142 16.03l-3.125 8.275a.524.524 0 00.098.527l16.759 16.753c4.597-4.318 7.47-10.45 7.47-17.256 0-8.146-4.116-14.862-10.38-19.121z"
				></path>
				<path
					fill="url(#paint2_linear_0:2325)"
					d="M23.67.658C10.599.658 0 11.256 0 24.33 0 37.402 10.598 48 23.67 48c13.074 0 23.672-10.597 23.672-23.67C47.342 11.256 36.744.66 23.67.66zm0 41.762c-9.99 0-18.09-8.1-18.09-18.09 0-9.992 8.1-18.092 18.09-18.092 9.992 0 18.092 8.1 18.092 18.091 0 9.991-8.1 18.091-18.091 18.091z"
				></path>
				<path
					fill="url(#paint3_linear_0:2325)"
					d="M23.672 11.925c-6.85 0-12.404 5.554-12.404 12.404s5.553 12.404 12.404 12.404c6.85 0 12.404-5.554 12.404-12.404s-5.554-12.404-12.404-12.404zm0 18.846a6.442 6.442 0 01-6.442-6.442 6.442 6.442 0 016.442-6.442 6.442 6.442 0 016.442 6.442 6.442 6.442 0 01-6.442 6.442z"
				></path>
				<path
					fill="url(#paint4_linear_0:2325)"
					d="M23.67 26.784a2.455 2.455 0 100-4.91 2.455 2.455 0 000 4.91z"
				></path>
				<path
					fill="url(#paint5_linear_0:2325)"
					d="M43.574 11.514c-2.012-2.556-4.324-4.751-6.613-6.306l-3.748 3.748c5.132 3.194 8.548 8.884 8.548 15.373 0 5.265-2.25 10.005-5.84 13.31l3.95 3.947a23.603 23.603 0 007.47-17.257c0-4.722-1.384-9.122-3.767-12.815z"
				></path>
				<path
					fill="url(#paint6_linear_0:2325)"
					d="M29.03 13.141l-2.89 2.889-.785 2.08a6.441 6.441 0 014.758 6.22c0 2.049-.956 3.874-2.446 5.055l4.23 4.228a12.365 12.365 0 004.178-9.283c0-4.931-2.878-9.19-7.045-11.189z"
				></path>
				<path
					fill="url(#paint7_linear_0:2325)"
					d="M23.927 21.889l-.912 2.416a.525.525 0 00.098.527l1.68 1.681a2.454 2.454 0 00-.866-4.624z"
				></path>
				<path
					fill="url(#paint8_linear_0:2325)"
					d="M26.141 15.562l-2.452 6.86-.304 1.908c-.151.423 2.193-.017 2.193-.017l6.86-2.453c1.745-1.744-4.553-8.042-6.297-6.298z"
				></path>
				<path
					fill="url(#paint9_linear_0:2325)"
					d="M47.644 6.655L32.438 21.86a2.025 2.025 0 00-.77-.75c-.459-.255-1.176-.116-1.672.035a.205.205 0 01-.248-.11.206.206 0 01-.002-.178h.001c.028-.064.052-.128.073-.193l.027-.093.001-.005c.027-.1.045-.2.056-.303l.008-.1a1.97 1.97 0 00-.805-1.695 1.967 1.967 0 00-1.672-.316h-.006c-.031.01-.062.02-.093.028a1.467 1.467 0 00-.19.073l-.003.001a.207.207 0 01-.177-.002.205.205 0 01-.11-.247c.15-.497.29-1.213.035-1.671a2.01 2.01 0 00-.75-.772L41.346.356a1.217 1.217 0 011.72 0l.898.898 2.783 2.782.897.898a1.217 1.217 0 010 1.72z"
				></path>
				<path
					fill="url(#paint10_linear_0:2325)"
					d="M46.746 4.036L29.748 21.035a.206.206 0 01-.002-.177l.001-.002c.028-.063.147-.492.157-.593.004-.034.006-.068.008-.1a1.967 1.967 0 00-.805-1.695 1.967 1.967 0 00-1.672-.316l-.006.001a5.582 5.582 0 00-.284.1l-.002.001a.208.208 0 01-.177-.002L43.964 1.254l2.782 2.782z"
				></path>
				<path
					fill="url(#paint11_linear_0:2325)"
					d="M24.78 23.22c-.33-.33-.7-.596-1.091-.797l-.674 1.882a.532.532 0 00.68.68l1.883-.673a4.38 4.38 0 00-.798-1.091z"
				></path>
			</g>
			<defs>
				<linearGradient
					id="paint0_linear_0:2325"
					x1="15.924"
					x2="42.011"
					y1="16.582"
					y2="42.67"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#fff"></stop>
					<stop offset="1" stopColor="#C7E9FF"></stop>
				</linearGradient>
				<linearGradient
					id="paint1_linear_0:2325"
					x1="39.556"
					x2="32.931"
					y1="25.914"
					y2="17.732"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#7ACBFF" stopOpacity="0"></stop>
					<stop offset="1" stopColor="#2F73A0"></stop>
				</linearGradient>
				<linearGradient
					id="paint2_linear_0:2325"
					x1="14.202"
					x2="46.088"
					y1="14.86"
					y2="46.746"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FF4181"></stop>
					<stop offset="1" stopColor="#843561"></stop>
				</linearGradient>
				<linearGradient
					id="paint3_linear_0:2325"
					x1="18.71"
					x2="35.419"
					y1="19.367"
					y2="36.076"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FF4181"></stop>
					<stop offset="1" stopColor="#843561"></stop>
				</linearGradient>
				<linearGradient
					id="paint4_linear_0:2325"
					x1="22.689"
					x2="25.996"
					y1="23.347"
					y2="26.654"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FF4181"></stop>
					<stop offset="1" stopColor="#843561"></stop>
				</linearGradient>
				<linearGradient
					id="paint5_linear_0:2325"
					x1="42.58"
					x2="33.891"
					y1="27.239"
					y2="18.55"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#843561" stopOpacity="0"></stop>
					<stop offset="1" stopColor="#3A2F4D"></stop>
				</linearGradient>
				<linearGradient
					id="paint6_linear_0:2325"
					x1="38.702"
					x2="30.013"
					y1="31.12"
					y2="22.43"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#843561" stopOpacity="0"></stop>
					<stop offset="1" stopColor="#3A2F4D"></stop>
				</linearGradient>
				<linearGradient
					id="paint7_linear_0:2325"
					x1="35.184"
					x2="26.494"
					y1="34.637"
					y2="25.948"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#843561" stopOpacity="0"></stop>
					<stop offset="1" stopColor="#3A2F4D"></stop>
				</linearGradient>
				<linearGradient
					id="paint8_linear_0:2325"
					x1="23.911"
					x2="30.208"
					y1="17.811"
					y2="24.108"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFE0EA"></stop>
					<stop offset="1" stopColor="#FFC0D5"></stop>
				</linearGradient>
				<linearGradient
					id="paint9_linear_0:2325"
					x1="26.141"
					x2="48"
					y1="10.93"
					y2="10.93"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFCE47"></stop>
					<stop offset="1" stopColor="#FF9356"></stop>
				</linearGradient>
				<linearGradient
					id="paint10_linear_0:2325"
					x1="39.469"
					x2="33.111"
					y1="13.757"
					y2="7.4"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#FFCE47"></stop>
					<stop offset="1" stopColor="#FF9356"></stop>
				</linearGradient>
				<linearGradient
					id="paint11_linear_0:2325"
					x1="23.786"
					x2="25.393"
					y1="23.852"
					y2="25.459"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#2F73A0"></stop>
					<stop offset="1" stopColor="#174461"></stop>
				</linearGradient>
				<clipPath id="clip0_0:2325">
					<path fill="#fff" d="M0 0H48V48H0z"></path>
				</clipPath>
			</defs>
		</svg>
	);
}

export default LockedVector;
